export default class RandomParticle {
  constructor(x, y, color) {
    this.x = x;
    this.y = y;
    this.color = color;
  }
}
